import $ from 'jquery';

export default function maybeEnhanceBreadcrumb() {
    if (!Modernizr.touchevents) {
        var $desktopBreadcrumb = $('.desktop-breadcrumb');

        $desktopBreadcrumb.jBreadCrumb({
            minimumCompressionElements: 2,
            previewWidth:               20,
            timeExpansionAnimation:     400,
            timeInitialCollapse:        400
        });

        // hide/show mask on focus/blur
        $desktopBreadcrumb.find('a').each(function() {
            var $anchor = $(this),
                $parent = $anchor.parent(),
                originalStyle = $anchor.attr('style');
            $anchor.on('focus', function() {
                $parent.css('mask-image', 'none');
            }).on('blur', function() {
                $parent.attr('style', originalStyle);
            });
        });
    }
}
